import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { triggerAPIRequest } from '../services/api.methods';
import { AuthContext } from '../App';
import './Auth.css';

const Auth = () => {
  const navigate = useNavigate();
  const { setIsAuthenticated, setIsAdmin } = useContext(AuthContext);
  const [isLogin, setIsLogin] = useState(true);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    accountName: ''
  });

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('token');
    if (token) {
      console.log('User is already logged in. token:', token);
      navigate('/');
    }
  }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    try {
      if (isLogin) {
        // Login logic
        const response = await triggerAPIRequest(
          'ufcdb',
          'db',
          'db_auth_user',
          {
            username: formData.email,
            password: formData.password
          },
          () => ({})
        );

        if (response.success && response.code === 200) {
          const { token, dbId } = response.message.result;
          if (token) {
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify({
              email: formData.email,
              id: dbId
            }));
            setIsAuthenticated(true);
            setIsAdmin(dbId === 1);
            navigate('/');
          } else {
            setError('Authentication successful but no token received');
          }
        } else {
          setError(response.message?.detail || 'Invalid username or password');
        }
      } else {
        // Register logic
        if (formData.password.length < 6) {
          setError('Password must have at least 6 characters.');
          return;
        }

        // First check if user exists
        const checkUser = await triggerAPIRequest(
          'ufcdb',
          'db',
          'check_if_user_exists',
          {
            email: formData.email
          },
          () => ({})
        );

        console.log('Check user response:', checkUser);

        // Check if user exists from message.result
        if (checkUser.success && checkUser.code === 200 && checkUser.message.result === true) {
          setError('This email is already registered. Please use a different email!');
          return;
        }

        // If user doesn't exist, proceed with registration
        const response = await triggerAPIRequest(
          'ufcdb',
          'db',
          'register_user',
          {
            email: formData.email,
            password: formData.password,
            user: formData.accountName
          },
          () => ({})
        );

        if (response.success && response.code === 200) {
          setIsLogin(true);
          setSuccessMessage('Account created successfully! Please login.');
          setFormData(prev => ({
            ...prev,
            password: '',
            accountName: ''
          }));
        } else {
          setError(response.message?.detail || 'Failed to create account');
        }
      }
    } catch (err) {
      console.error('Auth error:', err);
      setError('Something went wrong. Please try again later.');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-form">
        <h2>UFC Bot</h2>
        <form onSubmit={handleSubmit} className={isLogin ? 'login-form' : 'register-form'}>
          {!isLogin && (
            <input
              type="text"
              name="accountName"
              placeholder="Account name"
              value={formData.accountName}
              onChange={handleInputChange}
              required
            />
          )}
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleInputChange}
            required
          />
          <button type="submit">
            {isLogin ? 'Login' : 'Create Account'}
          </button>
          {error && <p className="error-message">{error}</p>}
          {successMessage && <p className="success-message">{successMessage}</p>}
          <p className="toggle-form">
            {isLogin ? "Not registered? " : "Already registered? "}
            <a href="#" onClick={(e) => {
              e.preventDefault();
              setIsLogin(!isLogin);
              setError('');
              setSuccessMessage('');
              setFormData({
                email: '',
                password: '',
                accountName: ''
              });
            }}>
              {isLogin ? 'Create an account' : 'Sign In'}
            </a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Auth; 